import ApplicationController from "../application_controller";

// Plays a muted looping video unless the visitor prefers reduced motion, in which case the poster stays up.
// Replaces the autoplay attribute, which browsers honor regardless of the reduced motion setting.
export default class MotionVideoController extends ApplicationController<HTMLVideoElement> {
  private reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  connect() {
    this.reducedMotion.addEventListener("change", this.sync);
    this.sync();
  }

  disconnect() {
    this.reducedMotion.removeEventListener("change", this.sync);
  }

  private sync = () => {
    if (this.reducedMotion.matches) {
      this.element.pause();
    } else {
      // play() rejects when the browser blocks it (e.g. Low Power Mode); the poster stays up
      this.element.play().catch(() => {});
    }
  };
}
